import { Typography } from '@material-ui/core';
import { PortraitSharp } from '@material-ui/icons';
import { Dispatch, SetStateAction } from 'react';
import { Button } from '../../../../themes/components/Button';

interface TypeFooterRelatorios {
    regraSalvar: boolean;
    regraCancelar: boolean;
    funcSalvar: () => void;
    funcCancelar: () => void;
}

export const FooterMenuNovoCliente = (props: TypeFooterRelatorios) => {
    return (
        <div className="container-footer-relatorios">
            <div className="footer-novo-pedido-info-area">
            </div>
            <div className="footer-novo-pedido-botoes-area">
                {props.regraCancelar ? <Button onClick={() => props.funcCancelar() } classBtn={"btn-footer-novo-pedido color-red"}>Cancelar</Button> : <></>}
                {props.regraSalvar ? <Button onClick={() => props.funcSalvar() } classBtn={"btn-footer-novo-pedido color-default"}>Salvar</Button> : <></>}
            </div>
        </div>
    )
}